import { useState, useEffect, useCallback } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import "../NewmasterPage/Master.css"
import '../../components/table.css';
import styles from "../transaction/transaction.module.css"
import searchicon_black from "../../icons/searchicon_black.png"
import style from "../../components/Search&Options/Search&Options.module.css"
import Order from "../order";
import moment from "moment"
import CircularProgress from '@mui/material/CircularProgress';
import * as XLSX from 'xlsx';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import "../../index.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import brandStyles from "../Brand/Brand.module.css";
import orderStyles from "./OrderList.module.css";
import "../../components/mcrbTableTheme.css";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';


//import { toast } from "react-toastify";
const { apiEndpoint, baseNodeapiUrl } = config;

var $ = require('jquery');

// const badgeMaker: any = {
//     "Created": (order_state: any) => <span className="badge badge-primary">{order_state}</span>,
//     "Shipped": (order_state: any) => <span className="badge badge-warning">{order_state}</span>,
//     "Delivered": (order_state: any) => <span className="badge badge-success">{order_state}</span>,
//     "Canceled": (order_state: any) => <span className="badge badge-danger">{order_state}</span>,
// }

const OrderList = () => {
    const decoded: any = tokenDecode();
    const current_seller_id = decoded?.data?.user?.seller_id
    const [orderList, setOrderList] = useState<any[]>([]);
    const [sorderList, setSorderList] = useState([]);

    const [sellerList, setSellerList] = useState([]);
    const [otherData, setOtherData] = useState<any[]>([]);
    const [updateOrder_, setUpdateOrder_]: any = useState({
        order_id: "",
        tracking_url: "",
        order_state: ""
    })
    const [orderDetail, setorderDetail]: any = useState([]);
    const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);
    const [_orderDetail, _setorderDetail]: any = useState({
        billing_address: "",
        contact_number: "",
        created_at: "",
        email: "",
        id: '',
        name: "",
        order_id: "",
        order_state: "",
        provider_id: "",
        shipping_address: "",
        status: "",
        total_price: 0
    });
    const rawData = {
        provider_id: ''
    }
    const Sstyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "16px",
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: '0 20px 50px rgba(43, 22, 87, 0.24)',
        outline: 'none',
        p: 3,
    };
    const [toggle, setToggle] = useState(false);
    const [searchData, setSearchData]: any = useState(rawData);

    const [valuename, setValuename] = useState("");
    const [valueid, setValueid] = useState("");
    const [valueemail, setValueemail] = useState("");
    const [valuecontact, setValuecontact] = useState("");
    const [valuestatus, setValuestatus] = useState("");
    const [valueamount, setValueamount] = useState("");
    const [valuedate, setValuedate] = useState("");
    const [orderisLoading, setorderisLoading] = useState(false);
    const [allorders, setallorders] = useState<any[]>([])
    const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
    const [updateorderstatus, setupdateorderstatus] = useState(false);
    const [exportOrderModalOpen, setexportOrderModalOpen] = useState(false);
    const [isExportingOrders, setIsExportingOrders] = useState(false);
    const [fraudModalOpen, setfraudModalOpen] = useState(false);
    const [isAnalyzing, setisAnalyzing] = useState(false)
    const [fraudLevel, setfraudLevel] = useState("");
    const [selectedCities, setSelectedCities] = useState<any>([]);
    const [singleSellerSelect, setsingleSellerSelect] = useState("");
    const [sellerFilterId, setSellerFilterId] = useState("");
    const [exportOrdersFilterState, setexportOrdersFilterState] = useState({
        month: "",
        year: ""
    })
    const { data } = decoded;
    const { permission: { seller, order } } = data;
    const [filterDaata, setfilterDaata] = useState({
        seller_id: "",
        orderCurrentStatus: "",
        endDate: ""
    })
    const [fraudDaata, setfraudDaata] = useState({
        provider_id: "",
        start_date: "",
        end_date: "",
        limit_count: "",
        limit_price: ""
    })

    function fraudChangeHandler(e: any) {
        setfraudDaata((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }

    var count = 1;
    function handleShipementModalClose() {
        setshipmentModalOpen(false)
    }
    function handleExportOrderModalClose() {
        setexportOrderModalOpen(false)
    }
    function handleFraudModalClose() {
        setfraudModalOpen(false)
    }

    function onDateandYearChangeHandler(e: any) {
        setexportOrdersFilterState((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }
    const [nextstep, setnextstep] = useState(1)
    const [totalPages, setTotalPages] = useState(1);  // ADD THIS LINE
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [pageInput, setPageInput] = useState("1");
    const [isClientFiltered, setIsClientFiltered] = useState(false);
    const displayedOrderList = isClientFiltered
        ? orderList.slice((nextstep - 1) * perPage, nextstep * perPage)
        : orderList;

    const setFilteredOrderResults = (results: any[]) => {
        const filteredResults = Array.isArray(results) ? results : [];
        setIsClientFiltered(true);
        setOrderList(filteredResults);
        setnextstep(1);
        setTotalPages(Math.max(1, Math.ceil(filteredResults.length / perPage)));
        setCurrentPage(1);
        setPageInput("1");
    };

    useEffect(() => {
        if (!isClientFiltered) {
            fetchSellerList(); // This always uses the latest nextStep
        }
    }, [nextstep, sellerFilterId, perPage, isClientFiltered]);
    function sellerFilterChangeHandler(e: any) {
        setIsClientFiltered(false);
        setSellerFilterId(e.target.value);
        setnextstep(1);
    }

    const fetchSellerList = async () => {
        setIsClientFiltered(false);
        let endpoint;
        if (decoded?.data?.user?.seller_id === 1 || decoded?.data?.user?.parent_id === 1) {
            endpoint = `getallorder?page=${nextstep}&per_page=${perPage}`
        } else {
            endpoint = "getsellerordercompletelist"
        }
        setorderisLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/${endpoint}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: sellerFilterId ? { seller_id: sellerFilterId } : {},
            });
            // console.log("order data -> ", data);
            if (data.status === 200) {
                setorderisLoading(false);
                setOrderList(data.data);
                setTotalPages(data.last_page || 1);
                setCurrentPage(data.current_page || 1);
                setPageInput(String(data.current_page || 1));

            }
        } catch (error) {
            console.log("error", error);

            setorderisLoading(false);
        }
    }

    const goToPage = (requestedPage: number) => {
        const page = Math.max(1, Math.min(requestedPage, totalPages));
        setnextstep(page);
        setPageInput(String(page));
        if (isClientFiltered) setCurrentPage(page);
    };

    // const [exceldataLoading, setexcelDataLoading] = useState(false)
    const allorderList = async () => {
        if (isExportingOrders) return;
        if (!startDate || !endDate) {
            setExportDateError("Select both a start date and an end date.");
            return;
        }
        if (startDate > endDate) {
            setExportDateError("Start date must be on or before the end date.");
            return;
        }
        setExportDateError("");

        const formatDate = (date: Date) =>
            `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;

        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const sellerId = decoded?.data?.user?.seller_id === 0
            ? decoded?.data?.user?.parent_id
            : decoded?.data?.user?.seller_id;

        setIsExportingOrders(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getallstatusorder`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    seller_id: sellerId,
                    startDate: formattedStartDate,
                    endDate: formattedEndDate,
                },

            });
            if (data.status === 200 || data.status === "success") {
                const rangeStart = new Date(startDate);
                rangeStart.setHours(0, 0, 0, 0);
                const rangeEnd = new Date(endDate);
                rangeEnd.setHours(23, 59, 59, 999);
                const orders = Array.isArray(data.data)
                    ? data.data.filter((order: any) => {
                        const createdAt = new Date(order?.created_at).getTime();
                        return Number.isFinite(createdAt)
                            && createdAt >= rangeStart.getTime()
                            && createdAt <= rangeEnd.getTime();
                    })
                    : [];
                setallorders(orders);
                if (orders.length === 0) {
                    toast.info("No orders found within the selected date range.");
                    return;
                }
                exportToExcel(orders);
                setexportOrderModalOpen(false);
                toast.success(`Exported ${orders.length} order${orders.length === 1 ? "" : "s"}.`);
            } else {
                toast.error(data.message || "Unable to export orders.");
            }
        } catch (error) {
            console.error("Order export failed:", error);
            toast.error("Unable to export orders. Please try again.");
        } finally {
            setIsExportingOrders(false);
        }
    };
    const updateOrder = async (order_id: any) => {
        try {

            const { data } = await axios({
                url: `${apiEndpoint}/updateorderstatus`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: updateOrder_
            });
            // console.log(data, "datadata");

            if (data.message === "flag1") {
                toast.success("Order updated !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                // fetchSellerList();
            } else {
                toast.error("Something went wrong !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        } catch (error) {
            console.log("update error", error);
            toast.error("404 error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            // window.location.reload();

        }
    }

    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data.filter((item: any) => item.approve_status === 1));
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        setValuename("");
        setValueid("");
        setValueemail("");
        setValuecontact("");
        setValuestatus("");
        setValueamount("");
        setValuedate("");
        var optionvalue = e.target.value;
        if (optionvalue) {
            try {
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbyseller`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        provider_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data);
                    setFilteredOrderResults(data.data);
                    setSorderList(data.data);
                    setToggle(true)
                }


            } catch (error) {
                console.log("error", error);
            }
        }
        else {
            setFilteredOrderResults(sorderList);
        }
    };
    const inputeHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuename(optionvalue);
        if (optionvalue) {
            try {
                const {
                    provider_id
                } = searchData;
                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        provider_id: { searchData },
                        name: optionvalue
                    }

                });


                if (data.status === 200) {
                    // console.log(data);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputeeHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuename(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        name: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputoHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {
                setToggle(true);
                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        // provider_id: { searchData },
                        order_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log("line 332", data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
            fetchSellerList()
        }
    };
    const inputooHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        order_id: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputemHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValueemail(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        email: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputeemHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueemail(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        email: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputcHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuecontact(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        contact_number: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputccHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuecontact(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        contact_number: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputpHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        status: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }


    };


    const inputOrderStatusHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: searchData?.provider_id,
                        order_state: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }


    };
    const inputppHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        status: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };

    const inputOOrderStatusHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        order_state: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputaHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueamount(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        order_total: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    }
    const inputaaHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueamount(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        order_total: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    }
    const inputdHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuedate(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        created_at: optionvalue
                    }

                });

                if (data.status === 200) {
                    setFilteredOrderResults(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    }
    console.log("orderList------->", orderList)
    const inputddHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuedate(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        created_at: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setFilteredOrderResults(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    }

    const COLUMNS = [
        {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Order ID",
            Footer: "Order ID",
            accessor: "order_id",
            sticky: "left"
        },
        {
            Header: "Order Status",
            Footer: "Order Status",
            accessor: "order_state",
            sticky: "left",

        },
        {
            id: 'sellerNameColumn',
            Header: () => (
                <div>
                    <select name="" value={singleSellerSelect} id="" style={{ color: "white", border: "none", width: "125px", textAlign: 'center' }} onChange={(e) => {
                        setsingleSellerSelect(e.target.value);
                        setfilterDaata((prev) => (
                            { ...prev, seller_id: e.target.value }
                        ))
                    }}>
                        <option value="" style={{ background: "#001ad5" }} disabled > Seller Name</option>
                        {
                            sellerList.map((item: any) => (
                                <option value={item?.seller_id} key={item?.seller_id} style={{ background: "#001ad5" }}>{item?.name}</option>
                            ))
                        }
                    </select>

                </div>
            ),
            Footer: "Seller Name",
            accessor: (row: any) => {
            let sellerName = row?.address?.start?.location?.descriptor?.name
                if (sellerName) {
                    return sellerName
                } else {
                try {
                    const fulfillments = typeof row?.fulfillments === "string"
                        ? JSON.parse(row.fulfillments)
                        : row?.fulfillments;
                    return fulfillments?.[0]?.start?.location?.descriptor?.name || "N/A";
                } catch {
                    return "N/A";
                }
                }
            },
            sticky: "left"
        },
        {
            Header: "Ageing (in days)",
            Footer: "Ageing",
            accessor: (row: any) => {
                if (row.order_state === "Completed" || row.order_state === "Cancelled") {

                    var date1 = moment(row.created_at);
                    var date2 = moment(row.updated_at);
                    var days = date2.diff(date1, 'days')
                    return days
                } else {

                    var date1 = moment(row.created_at);
                    var date2 = moment(new Date());
                    var days = date2.diff(date1, 'days')
                    return days
                }

            },
            sticky: "left"
        },
        {
            Header: "Customer name",
            Footer: "Customer name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "Total (In Rs)",
            Footer: "Total",
            accessor: "order_total",
            sticky: "left"
        },
        {
            Header: "Payment Status",
            Footer: "Payment Status",
            accessor: (row: any) => {
                return <>{row.status === "NOT-PAID" ? "COD" : "PAID"}</>
            },
            sticky: "left"
        },
        {
            Header: "Created Date",
            Footer: "Created Date",
            accessor: (row: any) => {
                if (row?.created_at) {
                    return moment.utc(row?.created_at).format("DD-MM-YYYY  HH:mm:ss")
                } else {
                    return ""
                }
            },
            sticky: "left"
        },
        {
            Header: "Tracking URL",
            Footer: "Tracking URL",
            accessor: "tracking_url",
            sticky: "left"
        },
        {
            Header: "shopify Order Id",
            accessor: (item: any) => (item?.shopify_order_id ? item?.shopify_order_id : ""),
            sticky: "left"
        },

        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return <div className="d-flex"><Link to={`../../orderCompleteDetail/${row.order_id}`} className="btn btn-success btn-circle"><i className="fas fa-pen"></i></Link>
                    <span className="btn btn-warning btn-circle" onClick={() => getorderDetailsByOrderID(row.order_id)}> <i className="fas fa-eye"  ></i> </span>   </div>
            },
            sticky: "left"
        },

    ];
    count++
    useEffect(() => {
        fetchSellerList();
        getSellerList();
        // allorderList()
        // getAllOrderList();
    }, [])
    useEffect(() => {
        if (selectedCities.length > 0 || singleSellerSelect !== "") {
            applyFilterHandler()
        } else {
            fetchSellerList()
        }

        // getAllOrderList();
    }, [selectedCities, singleSellerSelect])


    const exportToExcel = (orders: any[]) => {
        if (!Array.isArray(orders) || orders.length === 0) {
            toast.info("No orders available to export.");
            return;
        }

        const headers = [
            "S.No",
            "Order Id",
            "Customer Name",
            "Customer Email",
            "Customer Contact",
            "Delivery Address",
            "Seller Name",
            "Seller Email",
            "Seller Contact",
            "Item Count",
            "Order Total",
            "Payment Status",
            "Fulfillment State",
            "Tracking URL",
            "Tracking Enabled",
            "Created At",
            "Order State",
            "BAP Id"
        ];

        const data = orders.map((order, index) => {
            const address = order?.address || {};
            const buyer = address?.end || {};
            const buyerLocation = buyer?.location?.address || {};
            const seller = address?.start || {};
            const deliveryAddress = [
                buyerLocation?.building,
                buyerLocation?.name,
                buyerLocation?.locality,
                buyerLocation?.city,
                buyerLocation?.state,
                buyerLocation?.area_code,
                buyerLocation?.country,
            ].filter(Boolean).join(", ");

            return {
                "S.No": index + 1,
                "Order Id": order?.order_id || "",
                "Customer Name": order?.name || buyer?.person?.name || "",
                "Customer Email": buyer?.contact?.email || order?.email || "",
                "Customer Contact": buyer?.contact?.phone || order?.contact_number || "",
                "Delivery Address": deliveryAddress,
                "Seller Name": seller?.location?.descriptor?.name || order?.company_name || "",
                "Seller Email": seller?.contact?.email || "",
                "Seller Contact": seller?.contact?.phone || "",
                "Item Count": order?.item_count ?? "",
                "Order Total": order?.order_total ?? order?.total_price ?? "",
                "Payment Status": order?.status || "",
                "Fulfillment State": address?.state?.descriptor?.code || order?.fulfillment_state || "",
                "Tracking URL": order?.tracking_url || "-",
                "Tracking Enabled": address?.tracking ? "Yes" : "No",
                "Created At": order?.created_at ? moment(order.created_at).format("DD-MM-YYYY hh:mm:ss") : "",
                "Order State": order?.order_state || "",
                "BAP Id": order?.bap_id || "",
            };
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, "Orders");
        XLSX.writeFile(wb, `orders_${new Date().getTime()}.xlsx`);
    };

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        // Add leading zero if month or day is a single digit
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    async function filterChangeHandler(e: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>) {
        if (e.target.name !== "orderCurrentStatus") {
            setfilterDaata((prev) => {
                return { ...prev, [e.target.name]: e.target.value }
            })
        } else {
            setfilterDaata((prev: any) => {
                return { ...prev, orderCurrentStatus: [e.target.value] }
            })
        }

    }

    async function applyFilterHandler() {
        let payload;
        if (selectedCities.length > 0) {
            payload = {
                date: filterDaata.endDate,
                order_status: [...selectedCities],
                seller_id: filterDaata.seller_id
            }
        } else {
            payload = {
                date: filterDaata.endDate,
                order_status: filterDaata.orderCurrentStatus,
                seller_id: filterDaata.seller_id
            }
        }
        setorderisLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/ordersfilter`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    // date: filterDaata.endDate,
                    // order_status: filterDaata.orderCurrentStatus,
                    // seller_id: filterDaata.seller_id
                    ...payload
                }

            });
            if (data.status === 200) {
                setFilteredOrderResults(data.data);
                setshipmentModalOpen(false)
                setorderisLoading(false);

            }
        } catch (error) {
            setorderisLoading(false);
            console.log("error", error);
        }
    }

    const preventMinus = (e: any) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    async function analyzerFunction() {
        setfraudLevel("")
        try {
            setisAnalyzing(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/analytics/fraudAnalytics_seller_order_count`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    ...fraudDaata
                }

            });
            if (data === "Low") {
                setfraudLevel("33%")
            }
            if (data === "Medium") {
                setfraudLevel("66%")
            }
            if (data === "High") {
                setfraudLevel("99%")
            }

            setisAnalyzing(false)
        } catch (error) {
            setisAnalyzing(false)
            console.log("error", error);
        }
    }

    const steps = [
        'Low',
        'Medium',
        'High',
    ];


    const allOptions = [
        "Accepted", "In-progress", "Completed", "Cancelled"
    ]
    const handleAutocompleteChange = (
        event: React.ChangeEvent<{}>,
        newSelectedCities: any
    ) => {
        setSelectedCities(newSelectedCities);
    };

    const [orderDetails, setOrderDetails] = useState(null);
    const [orderUpdateModal, setorderUpdateModal] = useState(false);
    const [orderStatus, setorderStatus] = useState([
        "Created",
        "Accepted",
        "In-progress",
        "Completed",

    ]);

    const [orderState, setOrderState] = useState({
        order_id: "",
        order_state: "",
        fulfillment_state: "",
        tracking_url: ""
    })

    function handleOrderUpdateModalClose() {
        setorderUpdateModal(false);
        setOrderState({
            order_id: "", order_state: "", fulfillment_state: "", tracking_url: ""
        });
        setorderStatus(["Created", "Accepted", "In-progress", "Completed"])
        setOrderDetails(null)
    }

    async function getorderDetailsByOrderID(order_id: string) {
       
        setOrderState((prev) => {
            return { ...prev, order_id: order_id }
        })
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerorder`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: {
                    order_id,
                },
            });

            // console.log("setOrderDetails--------->", data?.data[0]?.order_state);

            if (data.status == 200) {
                setOrderDetails(data);
                setOrderState((prev) => {
                    return {
                        ...prev,
                        order_id: data?.data?.[0]?.order_id || order_id,
                        order_state: data?.data?.[0]?.order_state || "",
                        fulfillment_state: data?.products?.[0]?.fulfillment_state || "",
                        tracking_url: data?.products?.[0]?.tracking_url ?? data?.data?.[0]?.tracking_url ?? "",
                    };
                })
                if (data.data?.[0]?.order_state) {

                    const index = orderStatus.findIndex((item) => item === data.data[0].order_state);

                    if (index !== -1) {
                        let slicedStatus = orderStatus.slice(index);

                        setorderStatus([...slicedStatus]);
                    }
                }
            } else {
                toast.error("Error getting order details!")
            }
            setorderUpdateModal(true)
        } catch (err) {
            toast.error("Something Went Wrong!!")
        }

    }

    const updateThisOrder = async (e: any) => {
        if (isUpdatingOrder) return;
        setIsUpdatingOrder(true);
        try {

            const { data } = await axios({
                url: `${apiEndpoint}/updateorderstatus`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: orderState,
            });


            if (data.status === 200) {
                toast.success("Order and tracking URL updated successfully!");
                setOrderList((orders: any[]) => orders.map((order) =>
                    order.order_id === orderState.order_id
                        ? { ...order, tracking_url: orderState.tracking_url }
                        : order
                ));
                handleOrderUpdateModalClose();
            } else {
                toast.error("Something went wrong !");
            }
        } catch (error) {
            toast.error("Something went wrong 500 !")
        } finally {
            setIsUpdatingOrder(false);
        }
    };

    async function updatetrackingurl() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "delivered": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }
    async function updateordershopify() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "all_orders": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }
    async function updateordertrack() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "delivered": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }

    const handleEdit = (orderId: string | number) => {
        console.log("Edit clicked for Order ID:", orderId);
        // Add your edit functionality here
        // Example: Open a modal or redirect
    };
    const handleView = (orderId: string) => {
        console.log("View clicked for Order ID:", orderId);
        // Example: Navigate to order details page
        // navigate(`../../orderCompleteDetail/${orderId}`);
    };
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [openmodalbtn, setopenmodalbtn] = useState(false)
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [exportDateError, setExportDateError] = useState("");
    const exportDisabled = !startDate || !endDate || startDate > endDate;

    const openExportOrderModal = () => {
        setExportDateError("");
        setexportOrderModalOpen(true);
    };

    const [storefile, setStoreFile] = useState(null)

    const handleFile = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalfile = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalcancel = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalupdate = (e: any) => {
        setStoreFile(e.target.files[0])
    }

    const Uploadfile = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/update_DB_completed_status`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfilemodal = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/cancel_order_rto`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

                    },
                }
            );
                      toast.success(res?.data?.message);

            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfilecancel = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/cancel_order`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfileupdate = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/import_order_status_send`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };

    const [openmodalhandler, setopenmodalhandler] = useState(false)
    const [openmodalcancel, setopenmodalcancel] = useState(false)

    const [showService, setShowService] = useState(false);
    const showAllService = () => {
      setShowService(!showService)
    }  


    const[openmodalupdate,setopenmodalupdate]=useState(false)

    return (
        <>
            <ThemeMaker>
                <div className={`${orderStyles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-frame`}>

                            {(current_seller_id === 1 || decoded?.data?.user?.parent_id === 1) ? <div>
                                <div className={`${brandStyles.headerBar} mcrb-headbar`}>
                                    <span className={brandStyles.title}>Order List</span>
                                </div>
                                {order?.read ?
                                        <div className={orderStyles.toolbarRow}>

                                            <div className="d-flex flex-column flex-md-row flex-wrap justify-content-end align-items-center w-100" style={{ gap: "11px" }}>
                                                <select
                                                    className={orderStyles.sellerSelect}
                                                    value={sellerFilterId}
                                                    onChange={sellerFilterChangeHandler}
                                                >
                                                    <option value="">All Sellers</option>
                                                    {sellerList.map((item: any) => (
                                                        <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name} ({item?.contact_no})</option>
                                                    ))}
                                                </select>

                                                <div className="d-flex justify-content-end bg-white" style={{ flex: "1 1 240px", minWidth: "220px" }}>

                                                    <Autocomplete
                                                        multiple
                                                        size="small"
                                                        id="checkboxes-tags-demo"
                                                        options={allOptions}
                                                        disableCloseOnSelect
                                                        getOptionLabel={(option: any) => option}
                                                        onChange={handleAutocompleteChange}
                                                        className="multiOrderStatusSelector"
                                                        value={selectedCities}
                                                        renderOption={(props, option: any, { selected }) => (
                                                            <li {...props}>
                                                                <Checkbox
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                    style={{ marginRight: 8 }}
                                                                    checked={selected}
                                                                />
                                                                {option}
                                                            </li>
                                                        )}
                                                        // style={{
                                                        //     maxWidth: "400px", width: "100%"
                                                        //     // width: "400px"
                                                        // }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Select Order Status" placeholder="Search" />
                                                        )}
                                                    />
                                                </div>

                                                <input type="text" className={orderStyles.searchInput} placeholder="Search..." onChange={(e) => { seller?.read ? inputoHandler(e) : inputooHandler(e) }} />

                                                <button
                                                    type="button"
                                                    className={brandStyles.primaryBtn}
                                                    onClick={openExportOrderModal}
                                                >
                                                    Export Orders
                                                </button>

                                                <div className={orderStyles.servicesWrap}>
                                                    {/* <button className={orderStyles.servicesBtn}
                                                        onClick={showAllService}>ALL Services
                                                    </button> */}
                                                    {showService && (
                                                        <div className={orderStyles.servicesDropdown}>

                                                            <button className={orderStyles.dropdownBtn} onClick={() => {
                                                                setshipmentModalOpen(true)
                                                            }}>Filters</button>

                                                            <button
                                                                className={orderStyles.dropdownBtn}
                                                                onClick={() => setopenmodalhandler(true)}
                                                            >
                                                                RTO
                                                            </button>
                                                            <button

                                                                className={orderStyles.dropdownBtn}
                                                                onClick={() => setopenmodalcancel(true)}
                                                            >
                                                                CANCEL
                                                            </button>

                                                            <button
                                                                title="Update On seller Side Only(In-Progress / Complete)"
                                                                className={orderStyles.dropdownBtn}
                                                                onClick={() => setopenmodalbtn(true)}
                                                            >
                                                                Update On Seller
                                                            </button>

                                                            <button
                                                                title="Update On Buyer app & NO Dashboard (In-Progress & Complete)"
                                                                className={orderStyles.dropdownBtn}
                                                                onClick={() => setopenmodalupdate(true)}
                                                            >
                                                                Update On Buyer & NO
                                                            </button>

                                                            <button
                                                                className={orderStyles.dropdownBtnPrimary}
                                                                onClick={() => setupdateorderstatus(true)} // ✅ open modal
                                                            >
                                                                Update order status
                                                            </button>

                                                            <button className={orderStyles.dropdownBtnPrimary} onClick={openExportOrderModal}>
                                                                Export Orders
                                                            </button>

                                                            <button className={`${orderStyles.dropdownBtn} d-none`} onClick={() => {
                                                                setfraudModalOpen(true)
                                                            }}>Fraud Analysis</button>

                                                        </div>
                                                    )}

                                                </div>
                                            </div>


                                        </div>
                                        : ""}
                                <div className={`search mt-1 d-none `}>
                                    <div className={`row w-100 d-flex m-0`} style={{ flexWrap: "wrap" }}>
                                        <div className={style.inputMain}>
                                            <img src={searchicon_black} alt="" />   <input type="search" name="order_id" placeholder="Search by order id" onChange={(e) => { seller?.read ? inputoHandler(e) : inputooHandler(e) }} value={valueid ? valueid : ""} />
                                        </div>

                                        <div className={`${style.inputMain} d-none`} >
                                            <img src={searchicon_black} alt="" />   <input type="search" name="name" placeholder="Search by name" onChange={(e) => { seller?.read ? inputeHandler(e) : inputeeHandler(e) }} value={valuename ? valuename : ""} />
                                        </div>

                                        <div className={`${style.inputMain} d-none`}>
                                            <img src={searchicon_black} alt="" />   <input type="search" name="email" placeholder="Search by email" onChange={(e) => { seller?.read ? inputemHandler(e) : inputeemHandler(e) }} value={valueemail ? valueemail : ""} />
                                        </div>

                                        <div className={`${style.inputMain} d-none`}>
                                            <img src={searchicon_black} alt="" />   <input type="search" name="contact_number" placeholder="Search by Contact" onChange={(e) => { seller?.read ? inputcHandler(e) : inputccHandler(e) }} value={valuecontact ? valuecontact : ""} />
                                        </div>


                                        <select name="payment_status" onChange={(e) => { seller?.read ? inputpHandler(e) : inputppHandler(e) }} value={valuestatus ? valuestatus : ""} className={style.selector} style={{ display: "none" }} >
                                            <option >Select Payment Status</option>
                                            <option value="NOT-PAID">Cod</option>
                                            <option value="pa">Paid</option>
                                        </select>
                                        <select name="order_status" onChange={(e) => { seller?.read ? inputOrderStatusHandler(e) : inputOOrderStatusHandler(e) }} value={valuestatus ? valuestatus : ""} className={style.selector} >
                                            <option >Select Order Status</option>
                                            <option value="Accepted">Accepted</option>
                                            <option value="Completed">Completed</option>
                                            <option value="In-progress">In-progress</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </select>

                                        <div className={`${style.inputMain} d-none`}>
                                            <img src={searchicon_black} alt="" />    <input type="search" name="amount" className="d-none" placeholder="Search by Amount" onChange={(e) => { seller?.read ? inputaHandler(e) : inputaaHandler(e) }} value={valueamount ? valueamount : ""} />
                                        </div>

                                        <div className="mt-3 w-100">
                                            <span style={{ lineHeight: "34px" }} className={style.date}>Search By Date:</span> <input type="date" name="date" placeholder="Search by Date" onChange={(e) => { seller?.read ? inputdHandler(e) : inputddHandler(e) }} value={valuedate ? valuedate : ""} className={style.inputTypeDate} />
                                        </div>
                                    </div>
                                </div>

                            </div> : null}


                            {/* <div className="card-body p-1" style={{ minHeight: "80vh" }} >
                                <div className="table-responsive ">

                                    {
                                        // decoded?.data?.user?.seller_id > 1 || (decoded?.data?.user?.seller_id == 0) ?
                                        orderisLoading ? <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div> :
                                            <div >
                                                <div className="showdiv">
                                                    <Paginated data={orderList} columns={COLUMNS} />
                                                </div>
                                                <div className="hidediv">

                                                    {displayedOrderList.map((item: any) => {
                                                        let sellerName = item?.address?.start?.location?.descriptor?.name
                                                        if (sellerName) {
                                                            sellerName = sellerName
                                                        } else {
                                                            const parsedData = JSON.parse(item?.fulfillments);
                                                            const selletName = parsedData[0]?.start?.location?.descriptor?.name

                                                            sellerName = selletName
                                                        }

                                                        return <div className="border p-1">
                                                            <div className="d-flex  mt-1 align-items-center" style={{ gap: "10px" }}>
                                                                <span className="genericlabel" style={{ width: "28%" }} >Order ID</span>
                                                                <span className="" style={{ fontSize: "14px", width: '70%' }}>{item?.order_id}</span>
                                                            </div>
                                                            <div className="d-flex  mt-1" style={{ gap: "10px" }}>
                                                                <span className="genericlabel " style={{ width: "28%" }} >Order Status</span>
                                                                <span className="" style={{ fontSize: "14px", width: '70%' }}>{item?.order_state}</span>
                                                            </div>
                                                            <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                                <span className="genericlabel " style={{ width: "28%" }} > Seller Name</span>
                                                                <span className="" style={{ fontSize: "14px", width: '70%' }}>{sellerName}</span>
                                                            </div>
                                                            <div className="d-flex mt-1" style={{ gap: "10px" }}>
                                                                <span className="genericlabel " style={{ width: "31%" }}>Payment Status</span>
                                                                <span className="" style={{ fontSize: "14px", width: '69%' }}>{item?.status}</span>
                                                            </div>
                                                            <div className="mt-2">
                                                                <Link to={`../../orderCompleteDetail/${item.order_id}`}> <p style={{ width: "120px", fontWeight: 600, borderRadius: "17px", color: "white", background: "blue", padding: "6px", textAlign: "center" }} >Check Order</p>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>}
                                </div>
                            </div> */}


                            <div className={brandStyles.bodyArea} style={{ minHeight: "50vh" }}>
                                {orderisLoading ? (
                                    // Loader while data is loading
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ minHeight: "30vh" }}
                                    >
                                        <CircularProgress />
                                    </div>
                                ) : orderList.length === 0 ? (
                                    // When no data is available
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ minHeight: "30vh" }}
                                    >
                                        <p>No data available</p>
                                    </div>
                                ) : (
                                    // Table when data is loaded
                                    <div className={orderStyles.tableWrap}>
                                        <table className={orderStyles.premiumTable}>
                                            <thead>
                                                <tr>
                                                    <th>Serial No.</th>
                                                    <th>Order ID</th>
                                                    <th>Order Status</th>
                                                    <th>Seller Name</th>
                                                    <th>Ageing (in days)</th>
                                                    <th>Customer Name</th> {/* ✅ FIXED */}
                                                    <th>Total (In Rs)</th>
                                                    <th>Payment Status</th>
                                                    <th>Created Date</th>
                                                    <th>Tracking URL</th>
                                                    {/* <th>Shopify Order Id</th> */}
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayedOrderList.map((item: any, index: number) => {
                                                    const statusPillClass =
                                                        item.order_state === "Completed" ? orderStyles.pillGreen :
                                                            item.order_state === "Cancelled" ? orderStyles.pillRed :
                                                                item.order_state === "In-progress" ? orderStyles.pillAmber :
                                                                    item.order_state === "Accepted" ? orderStyles.pillBlue :
                                                                        orderStyles.pillGrey;

                                                    return (
                                                        <tr key={index}>
                                                            <td>{(nextstep - 1) * perPage + index + 1}</td>
                                                            <td>{item.order_id}</td>
                                                            <td><span className={`${orderStyles.pillBase} ${statusPillClass}`}>{item.order_state || "N/A"}</span></td>
                                                            <td>{item.company_name}</td>
                                                            <td>{item.ageing || 0}</td>

                                                            {/* ✅ FIXED: Use item.name directly from API */}
                                                            <td>{item?.name || "N/A"}</td>

                                                            <td>{item.order_total || 0}</td> {/* ✅ FIXED total key */}
                                                            <td><span className={`${orderStyles.pillBase} ${item.status === "NOT-PAID" ? orderStyles.pillAmber : orderStyles.pillGreen}`}>{item.status === "NOT-PAID" ? "COD" : "PAID"}</span></td>
                                                            <td>{item.created_at}</td>
                                                            <td>
                                                                {item.tracking_url ? (
                                                                    <a
                                                                        href={item.tracking_url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className={orderStyles.trackLink}
                                                                    >
                                                                        <i className="bi bi-truck"></i> Track
                                                                    </a>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </td>
                                                            {/* <td>{item.shopify_order_id || "N/A"}</td> */}

                                                            {/* Action Buttons */}
                                                            <td>
                                                                <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                                                    {/* Edit Icon */}
                                                                    <Link
                                                                        to={`../../orderCompleteDetail/${item.order_id}`}
                                                                        className={brandStyles.iconBtn}
                                                                        title="Edit Order"
                                                                    >
                                                                        <EditNoteRoundedIcon style={{ color: "#4c2fb3" }} />
                                                                    </Link>

                                                                    {/* View Icon */}
                                                                    <span
                                                                        className={brandStyles.iconBtn}
                                                                        onClick={() => getorderDetailsByOrderID(item.order_id)}
                                                                        title="Update Tracking URL"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === "Enter" || event.key === " ") {
                                                                                getorderDetailsByOrderID(item.order_id);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} />
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        <div className="my-3 d-flex flex-column justify-content-center align-items-center">
                                            <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ fontSize: "12px" }}>
                                                <button
                                                    className="page_link_item"
                                                    onClick={() => goToPage(currentPage - 1)}
                                                    disabled={currentPage <= 1}
                                                >
                                                    Previous
                                                </button>
                                                <span className="page_link_item">
                                                    Page <strong>{currentPage} of {totalPages}</strong>
                                                </span>
                                                <label className="page_link_item">
                                                    | Go to page:
                                                    <input
                                                        type="number"
                                                        min={1}
                                                        max={totalPages}
                                                        value={pageInput}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const page = Number(value);
                                                            setPageInput(value);
                                                            if (page >= 1 && page <= totalPages) goToPage(page);
                                                        }}
                                                        style={{ width: "50px" }}
                                                    />
                                                </label>
                                                <button
                                                    className="page_link_item"
                                                    onClick={() => goToPage(currentPage + 1)}
                                                    disabled={currentPage >= totalPages}
                                                >
                                                    Next
                                                </button>
                                                <select
                                                    className="page_link_item"
                                                    value={perPage}
                                                    onChange={(e) => {
                                                        const nextPerPage = Number(e.target.value);
                                                        setPerPage(nextPerPage);
                                                        goToPage(1);
                                                        if (isClientFiltered) {
                                                            setTotalPages(Math.max(1, Math.ceil(orderList.length / nextPerPage)));
                                                        }
                                                        setPageInput("1");
                                                    }}
                                                >
                                                    {[20, 50, 100].map((size) => (
                                                        <option key={size} value={size}>Show {size}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>





                        </div>
                    </div>



                <>
                    <Modal
                        open={openmodalbtn}
                        onClose={() => setopenmodalbtn(false)}
                        disableEscapeKeyDown={true}
                        BackdropProps={{
                            onClick: (e) => e.stopPropagation(),
                        }}
                    >
                        <Box sx={Sstyle} className="col-md-3" style={{ position: "relative" }}>

                            {/* ❌ Close icon */}
                            <CloseIcon
                                onClick={() => setopenmodalbtn(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    cursor: "pointer",
                                    fontSize: "22px",
                                    color: "#555",
                                }}
                            />

                            <div style={{



                            }}>
                                <h5 className=" d-flex justify-content-center fw-bold mb-4" style={{ color: "#000" }}>Upload Excel File (.xlsx)</h5>

                                <input
                                    style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                                    type="file"
                                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onChange={handleFile}


                                />
                            </div>
                            <button className=" btn btn-primary d-flex  m-auto"
                                onClick={Uploadfile}
                            >
                                Submit
                            </button>
                        </Box>
                    </Modal>

                </>

                <>
                    <Modal
                        open={openmodalhandler}
                        onClose={() => setopenmodalhandler(false)}
                        disableEscapeKeyDown={true}
                        BackdropProps={{
                            onClick: (e) => e.stopPropagation(),
                        }}
                    >
                        <Box sx={Sstyle} className="col-md-3" style={{ position: "relative" }}>

                            {/* ❌ Close icon */}
                            <CloseIcon
                                onClick={() => setopenmodalhandler(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    cursor: "pointer",
                                    fontSize: "22px",
                                    color: "#555",
                                }}
                            />

                            <div style={{



                            }}>
                                <h5 className=" d-flex justify-content-center fw-bold mb-4" style={{ color: "#000" }}>Upload Excel File (.xlsx)</h5>

                                <input
                                    style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                                    type="file"
                                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onChange={handlemodalfile}


                                />
                            </div>
                            <button className=" btn btn-primary d-flex  m-auto"
                                onClick={Uploadfilemodal}
                            >
                                Submit
                            </button>
                        </Box>
                    </Modal>

                </>


                <>
                    <Modal
                        open={openmodalcancel}
                        onClose={() => setopenmodalcancel(false)}
                        disableEscapeKeyDown={true}
                        BackdropProps={{
                            onClick: (e) => e.stopPropagation(),
                        }}
                    >
                        <Box sx={Sstyle} className="col-md-3" style={{ position: "relative" }}>

                            {/* ❌ Close icon */}
                            <CloseIcon
                                onClick={() => setopenmodalcancel(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    cursor: "pointer",
                                    fontSize: "22px",
                                    color: "#555",
                                }}
                            />

                            <div style={{



                            }}>
                                <h5 className=" d-flex justify-content-center fw-bold mb-4" style={{ color: "#000" }}>Upload Excel File (.xlsx)</h5>

                                <input
                                    style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                                    type="file"
                                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onChange={handlemodalcancel}


                                />
                            </div>
                            <button className=" btn btn-primary d-flex  m-auto"
                                onClick={Uploadfilecancel}
                            >
                                Submit
                            </button>
                        </Box>
                    </Modal>

                </>
                <>
                    <Modal
                        open={openmodalupdate}
                        onClose={() => setopenmodalupdate(false)}
                        disableEscapeKeyDown={true}
                        BackdropProps={{
                            onClick: (e) => e.stopPropagation(),
                        }}
                    >
                        <Box sx={Sstyle} className="col-md-3" style={{ position: "relative" }}>

                            {/* ❌ Close icon */}
                            <CloseIcon
                                onClick={() => setopenmodalupdate(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    cursor: "pointer",
                                    fontSize: "22px",
                                    color: "#555",
                                }}
                            />

                            <div style={{



                            }}>
                                <h5 className=" d-flex justify-content-center fw-bold mb-4" style={{ color: "#000" }}>Upload Excel File (.xlsx)</h5>

                                <input
                                    style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                                    type="file"
                                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onChange={handlemodalupdate}


                                />
                            </div>
                            <button className=" btn btn-primary d-flex  m-auto"
                                onClick={Uploadfileupdate}
                            >
                                Submit
                            </button>
                        </Box>
                    </Modal>

                </>

                <>
                    <Modal
                        open={exportOrderModalOpen}
                        onClose={handleExportOrderModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box className={orderStyles.exportModal}>
                            <div className={orderStyles.exportModalHeader}>
                                <div>
                                    <h2 id="modal-modal-title" className={orderStyles.exportModalTitle}>Export orders</h2>
                                    <p className={orderStyles.exportModalSubtitle}>Choose a date range for the Excel export.</p>
                                </div>
                                <button
                                    type="button"
                                    className={orderStyles.exportModalClose}
                                    aria-label="Close export dialog"
                                    onClick={handleExportOrderModalClose}
                                >
                                    <CloseIcon />
                                </button>
                            </div>

                            <div className={orderStyles.exportModalBody}>
                                <div className={orderStyles.exportDateGrid}>
                                    <div className={orderStyles.exportDateField}>
                                        <label htmlFor="orders-export-start-date">Start date</label>
                                        <DatePicker
                                            id="orders-export-start-date"
                                            selected={startDate}
                                            onChange={(date) => {
                                                if (date && endDate && date > endDate) {
                                                    setExportDateError("Start date must be on or before the end date.");
                                                    return;
                                                }
                                                setStartDate(date);
                                                setExportDateError("");
                                            }}
                                            placeholderText="Select start date"
                                            className={orderStyles.exportDateInput}
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={endDate || undefined}
                                            popperClassName={orderStyles.exportDatePopper}
                                            isClearable
                                        />
                                    </div>

                                    <div className={orderStyles.exportDateField}>
                                        <label htmlFor="orders-export-end-date">End date</label>
                                        <DatePicker
                                            id="orders-export-end-date"
                                            selected={endDate}
                                            onChange={(date) => {
                                                if (date && startDate && date < startDate) {
                                                    setExportDateError("End date must be on or after the start date.");
                                                    return;
                                                }
                                                setEndDate(date);
                                                setExportDateError("");
                                            }}
                                            placeholderText="Select end date"
                                            className={orderStyles.exportDateInput}
                                            dateFormat="dd-MM-yyyy"
                                            minDate={startDate || undefined}
                                            popperClassName={orderStyles.exportDatePopper}
                                            isClearable
                                        />
                                    </div>
                                </div>

                                {exportDateError && (
                                    <p className={orderStyles.exportDateError} role="alert">{exportDateError}</p>
                                )}
                                <p className={orderStyles.exportDateHint}>Both dates are required. The selected dates are included.</p>
                            </div>


                                {/* Radio Buttons
                                <div className="mb-3 d-flex justify-content-start gap-3">
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            name="exportType"
                                            id="exportExcel"
                                            value="excel"
                                            onChange={(e: any) => setExportType(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="exportExcel" >
                                            Excel
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            name="exportType"
                                            id="exportCsv"
                                            value="csv"
                                            onChange={(e: any) => setExportType(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="exportCsv">
                                            CSV
                                        </label>
                                    </div>
                                </div> */}


                            <div className={orderStyles.exportModalFooter}>
                                <button
                                    type="button"
                                    className={orderStyles.exportCancelButton}
                                    onClick={handleExportOrderModalClose}
                                    disabled={isExportingOrders}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    disabled={exportDisabled || isExportingOrders}
                                    className={orderStyles.exportSubmitButton}
                                    onClick={allorderList}
                                >
                                    {isExportingOrders ? <><CircularProgress size={16} color="inherit" /> Exporting...</> : "Export Orders"}
                                </button>
                            </div>
                        </Box>
                    </Modal>
                </>

                <>
                    <Modal
                        open={updateorderstatus}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-3 w-75 w-md-25">

                            <div className="d-flex flex-column gap-2 ">
                                <button
                                    className="btn btn-primary commonBtn mb-2"

                                    onClick={() => updatetrackingurl()}
                                    style={{ letterSpacing: "1px" }}
                                >
                                    Update Tracking Url
                                </button>

                                <button

                                    className="btn btn-primary commonBtn mb-2"
                                    title="Update Url Using Shopify"
                                    onClick={() => updateordershopify()}
                                    style={{ letterSpacing: "1px" }}
                                >
                                    Update Order
                                </button>

                                <button

                                    className="btn btn-primary commonBtn"
                                    title="Update Order Using Tracking Url"
                                    onClick={() => updateordertrack()}
                                    style={{ letterSpacing: "1px" }}
                                >
                                    Update Order
                                </button>
                            </div>

                            <div className="text-center">
                                <button
                                    className="btn btn-secondary mt-3 "
                                    onClick={() => setupdateorderstatus(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </Box>
                    </Modal>
                </>

                <>
                    <Modal
                        open={shipmentModalOpen}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-3 w-75 w-md-25">

                            <div className="modal-content ">
                                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                                    <p className="modal-title genericlabel  " style={{ letterSpacing: "3px" }}>Filters:</p>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <select name="seller_id" id="" className="form-control" value={filterDaata.seller_id} onChange={filterChangeHandler}>
                                            <option value="" disabled selected >Select Seller</option>
                                            {
                                                sellerList.map((item: any) => (
                                                    <option value={item?.seller_id} key={item?.seller_id}>{item?.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className="mt-2">
                                        <select name="orderCurrentStatus" id="" className="form-control" value={filterDaata.orderCurrentStatus} onChange={filterChangeHandler}>
                                            <option value="" disabled selected >Select Order Status</option>
                                            <option value="Accepted" className="form-control">Accepted</option>
                                            <option value="Completed">Completed</option>
                                            <option value="In-progress">In-progress</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </select>
                                    </div>

                                    <div className="mt-2">
                                        <input type="date" name="endDate" className="form-control" max={getCurrentDate()} value={filterDaata.endDate} onChange={filterChangeHandler} />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={() => {
                                        fetchSellerList(); setshipmentModalOpen(false); setfilterDaata({
                                            seller_id: "",
                                            orderCurrentStatus: "",
                                            endDate: ""
                                        })
                                    }} >Clear Filter</button>
                                    <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={applyFilterHandler} >Apply Changes</button>
                                </div>


                            </div>
                        </Box>
                    </Modal>
                </>

                {/* ------------------  FRAUD MODAL -------------------------- */}
                <>
                    <Modal
                        open={fraudModalOpen}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-3 w-75 w-md-25">

                            <div className="modal-content ">
                                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                                    <p className="modal-title genericlabel  " style={{ letterSpacing: "3px" }}>Fraud Analysys:</p>
                                    <div className="d-flex align-items-center" style={{ gap: "14px" }}>


                                        {(fraudDaata.provider_id && fraudDaata.limit_count) && <span className="d-block text-center" style={{ width: "60px", padding: "1px", cursor: "pointer", borderRadius: "20px", fontSize: "12px", background: "lightgrey", height: "20px" }} onClick={() => {
                                            setfraudDaata({
                                                provider_id: "",
                                                start_date: "",
                                                end_date: "",
                                                limit_count: "",
                                                limit_price: ""
                                            });
                                            setfraudLevel("")
                                        }} >Clear</span>}


                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleFraudModalClose} /></span>
                                        </button>

                                    </div>

                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label htmlFor="" className="genericlabel" >Choose Seller</label> <span className="text-danger" > * </span>
                                        <select name="provider_id" id="" className="form-control" value={fraudDaata.provider_id} onChange={fraudChangeHandler}>
                                            <option value="" disabled selected >Select Seller</option>
                                            {
                                                sellerList.map((item: any) => (
                                                    <option value={item?.provider_id} key={item?.seller_id}>{item?.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Order Limit</label> <span className="text-danger" > * </span>
                                        <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_count} name="limit_count" className="form-control" onChange={fraudChangeHandler} />
                                    </div>
                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Price Limit</label> <span className="text-danger" > * </span>
                                        <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_price} name="limit_price" className="form-control" onChange={fraudChangeHandler} />
                                    </div>

                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Start Date</label> <span className="text-danger" > * </span>
                                        <input type="date" value={fraudDaata.start_date} name="start_date" className="form-control" max={getCurrentDate()} onChange={fraudChangeHandler} />
                                    </div>
                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >End Date</label> <span className="text-danger" > * </span>
                                        <input type="date" value={fraudDaata.end_date} name="end_date" className="form-control" max={getCurrentDate()} onChange={fraudChangeHandler} />
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    {/* <button type="button" className="btn btn-danger" onClick={() => {
                                        fetchSellerList(); setshipmentModalOpen(false); setfilterDaata({
                                            seller_id: "",
                                            orderCurrentStatus: "",
                                            endDate: ""
                                        })
                                    }} >Clear Filter</button> */}
                                    <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={analyzerFunction} disabled={(fraudDaata.end_date && fraudDaata.start_date && fraudDaata.limit_count && fraudDaata.limit_price && fraudDaata.provider_id) ? false : true} >{isAnalyzing ? "Please Wait.." : "Analyze"}</button>

                                    {fraudLevel !== "" && <div className="" style={{ width: "60%" }}>

                                        <div>
                                            <div className="progress">
                                                <div className="progress-bar bg-success" role="progressbar" style={{ width: `${fraudLevel}` }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                            <div className="d-flex justify-content-around mt-2" >
                                                {steps.map(item => {
                                                    return <span className="genericlabel">{item}</span>
                                                })}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </Box>
                    </Modal>
                </>

                {/* ------------------  FRAUD MODAL -------------------------- */}


            </ThemeMaker >

            <Modal
                open={orderUpdateModal}
                onClose={isUpdatingOrder ? undefined : handleOrderUpdateModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={`${orderStyles.exportModal} ${orderStyles.orderUpdateModal}`}>
                    <div className={orderStyles.exportModalHeader}>
                        <div>
                            <h2 id="modal-modal-title" className={orderStyles.exportModalTitle}>Update order</h2>
                            <p className={orderStyles.exportModalSubtitle}>Order ID: {orderState.order_id}</p>
                        </div>
                        <button
                            type="button"
                            className={orderStyles.exportModalClose}
                            aria-label="Close order update dialog"
                            onClick={handleOrderUpdateModalClose}
                            disabled={isUpdatingOrder}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <div className={orderStyles.orderUpdateBody}>
                        {orderState.order_state === "Cancelled" ? (
                            <div className={orderStyles.cancelledOrderNotice}>This order is cancelled. You can still update its tracking URL.</div>
                        ) : (
                            <div className={orderStyles.orderUpdateGrid}>
                                <div className={orderStyles.orderUpdateField}>
                                    <label htmlFor="order-update-status">Order status</label>
                                    <select
                                        id="order-update-status"
                                        value={orderState.order_state}
                                        onChange={(e) => setOrderState((prev) => ({ ...prev, order_state: e.target.value }))}
                                    >
                                        <option value="" disabled>Select order status</option>
                                        {orderStatus.map((item) => <option value={item} key={item}>{item}</option>)}
                                    </select>
                                </div>

                                <div className={orderStyles.orderUpdateField}>
                                    <label htmlFor="order-update-fulfillment">Fulfillment status</label>
                                    <select
                                        id="order-update-fulfillment"
                                        value={orderState.fulfillment_state}
                                        onChange={(e) => setOrderState((prev) => ({ ...prev, fulfillment_state: e.target.value }))}
                                    >
                                        <option value="">Select fulfillment status</option>
                                        {(orderState.order_state === "Created" || orderState.order_state === "Accepted") && <option value="Pending">Pending</option>}
                                        {orderState.order_state === "In-progress" && <>
                                            <option value="Packed">Packed</option>
                                            <option value="Order-picked-up">Order-picked-up</option>
                                            <option value="Out-for-delivery">Out-for-delivery</option>
                                        </>}
                                        {orderState.order_state === "Completed" && <option value="Order-delivered">Delivered</option>}
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className={orderStyles.orderUpdateField}>
                            <label htmlFor="order-update-tracking">Tracking URL</label>
                            <input
                                id="order-update-tracking"
                                type="text"
                                placeholder="https://carrier.example/track/..."
                                value={orderState.tracking_url}
                                onChange={(e) => setOrderState((prev) => ({ ...prev, tracking_url: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div className={orderStyles.exportModalFooter}>
                        <button
                            type="button"
                            className={orderStyles.exportCancelButton}
                            onClick={handleOrderUpdateModalClose}
                            disabled={isUpdatingOrder}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={orderStyles.exportSubmitButton}
                            onClick={updateThisOrder}
                            disabled={isUpdatingOrder}
                        >
                            {isUpdatingOrder ? <><CircularProgress size={16} color="inherit" /> Saving...</> : "Save changes"}
                        </button>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default OrderList;
